import * as EXPLORER_ACTION from 'js/constant/action/explorer'
import { handleActions } from 'redux-actions'

const initialState = {
  loader: true,
  output: null,
  allContacts: [],
  allNodes: [],
  allEdges: [],
  lastSession: true,
  networkViewParams: undefined,
  networkViewUrl: undefined,
  viewNode: [],
  network: undefined,
  singleNode: [],
  customerLayer: [],
  networkBreadcrumb: false,
  networkBreadcrumbData: [],
  explorerFilterData: [],
  networkFilter: false,
  noResultsModal: false,
  noResultsData: [],
  productData: [],
  productModal: false,
  customerEdges: [],
  customerData: [],
  customerModal: false,
  metadataData: [],
  metadataOpen: true,
  resultMessage: [],
  retailers: [],
  resultModal: false,
  explorerPagination: undefined,
  edgesInfo: null,
  nodesInfo: null,
  expandCustomerNodes: null,
  listCustomerDetails: null,
  expandContactNodes: null,
  listContactDetails: null,
  disconnnectNodes: null,
  expandRecursively: null,
  totalNetworkValue: 0
}

export default handleActions(
  {
    [EXPLORER_ACTION.UPDATE_EXPLORER_LOADER]: (state, action) => ({
      ...state,
      loader: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_ALL_CONTACTS]: (state, action) => ({
      ...state,
      allContacts: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_OUTPUT]: (state, action) => ({
      ...state,
      output: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_ALL_NODES]: (state, action) => ({
      ...state,
      allNodes: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_ALL_EDGES]: (state, action) => ({
      ...state,
      allEdges: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_LAST_SESSION]: (state, action) => ({
      ...state,
      lastSession: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NETWORK_VIEW_PARAMS]: (state, action) => ({
      ...state,
      networkViewParams: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NETWORK_VIEW_URL]: (state, action) => ({
      ...state,
      networkViewUrl: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_VIEW_NODE]: (state, action) => ({
      ...state,
      viewNode: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NETWORK]: (state, action) => ({
      ...state,
      network: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_SINGLE_NODE]: (state, action) => ({
      ...state,
      singleNode: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_CUSTOMER_LAYER]: (state, action) => ({
      ...state,
      customerLayer: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NETWORK_BREADCRUMB]: (state, action) => ({
      ...state,
      networkBreadcrumb: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NETWORK_FILTER]: (state, action) => ({
      ...state,
      networkFilter: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NETWORK_BREADCRUMB_DATA]: (state, action) => ({
      ...state,
      networkBreadcrumbData: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_EXPLORER_FILTER_DATA]: (state, action) => ({
      ...state,
      explorerFilterData: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NO_RESULT_DATA]: (state, action) => ({
      ...state,
      noResultsData: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NO_RESULT_MODAL]: (state, action) => ({
      ...state,
      noResultsModal: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_RETAILERS]: (state, action) => ({
      ...state,
      retailers: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_PRODUCT_MODAL]: (state, action) => ({
      ...state,
      productModal: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_PRODUCT_DATA]: (state, action) => ({
      ...state,
      productData: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_CUSTOMER_MODAL]: (state, action) => ({
      ...state,
      customerModal: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_CUSTOMER_DATA]: (state, action) => ({
      ...state,
      customerData: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_CUSTOMER_EDGES]: (state, action) => ({
      ...state,
      customerEdges: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_METADATA_OPEN]: (state, action) => ({
      ...state,
      metadataOpen: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_METADATA_DATA]: (state, action) => ({
      ...state,
      metadataData: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_RESULT_MESSAGE]: (state, action) => ({
      ...state,
      resultMessage: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_RESULT_MODAL]: (state, action) => ({
      ...state,
      resultModal: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_EXPLORER_PAGINATION]: (state, action) => ({
      ...state,
      explorerPagination: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_NODES_INFO]: (state, action) => ({
      ...state,
      nodesInfo: action.payload
    }),
    [EXPLORER_ACTION.UPDATE_EDGES_INFO]: (state, action) => ({
      ...state,
      edgesInfo: action.payload
    }),
    [EXPLORER_ACTION.EXPAND_CUSTOMER_NODES]: (state, action) => ({
      ...state,
      expandCustomerNodes: !state.expandCustomerNodes
    }),
    [EXPLORER_ACTION.LIST_CUSTOMER_DETAILS]: (state, action) => ({
      ...state,
      listCustomerDetails: !state.listCustomerDetails
    }),
    [EXPLORER_ACTION.EXPAND_CONTACT_NODES]: (state, action) => ({
      ...state,
      expandContactNodes: !state.expandContactNodes
    }),
    [EXPLORER_ACTION.LIST_CONTACT_DETAILS]: (state, action) => ({
      ...state,
      listContactDetails: !state.listContactDetails
    }),
    [EXPLORER_ACTION.DISCONNECT_NODES]: (state, action) => ({
      ...state,
      disconnectNodes: !state.disconnectNodes
    }),
    [EXPLORER_ACTION.EXPAND_RECURSIVELY]: (state, action) => ({
      ...state,
      expandRecursively: !state.expandRecursively
    }),
    [EXPLORER_ACTION.UPDATE_TOTAL_NETWORK_VALUE]: (state, action) => ({
      ...state,
      totalNetworkValue: action.payload
    }),
  },
  initialState
)
